import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { LayerListEffectModule } from '../layer-list-effect/layer-list-effect.module';
import { ClusterLayersComponent } from './cluster-layers.component';

@NgModule({
  imports: [CommonModule, LayerListEffectModule],
  declarations: [ClusterLayersComponent],
  exports: [ClusterLayersComponent],
})
export class ClusterLayersModule {}
